export default function CAPA(props: any) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13.6405 27.2832H11.2177C8.94269 27.2832 7.6438 24.6854 9.01269 22.8693L14.1771 15.9898C14.9277 14.9904 16.4249 14.9904 17.1755 15.9898L22.3399 22.8693C23.7049 24.6893 22.406 27.2832 20.1349 27.2832H17.5216"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.8843 25.6422C13.0287 25.1599 12.4688 24.3433 12.4688 23.4177C12.4688 21.936 13.9037 20.7344 15.6732 20.7344C17.4426 20.7344 18.8776 21.936 18.8776 23.4177C18.8776 24.3433 18.3176 25.1599 17.466 25.6422"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.9531 23.1685C13.9531 22.5113 14.7231 21.9785 15.672 21.9785C16.6209 21.9785 17.3948 22.5113 17.3948 23.1685"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M13.9531 23.4141V30.4996" stroke="#757575" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.3906 23.4141V30.4996" stroke="#757575" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M17.3948 23.1699C17.3948 23.6405 16.6248 24.0177 15.6759 24.0177C14.727 24.0177 13.9531 23.6366 13.9531 23.1699"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.3948 25.082C17.3948 25.5526 16.6248 25.9298 15.6759 25.9298C14.727 25.9298 13.9531 25.5487 13.9531 25.082"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.3948 27C17.3948 27.4706 16.6248 27.8478 15.6759 27.8478C14.727 27.8478 13.9531 27.4667 13.9531 27"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.3948 28.918C17.3948 29.3885 16.6248 29.7657 15.6759 29.7657C14.727 29.7657 13.9531 29.3846 13.9531 28.918"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.6822 29.523C13.6822 29.523 12.3288 27.6875 10.7344 27.2402"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.36328 13.2367C8.47217 13.194 10.8561 11.4556 13.0066 13.4428"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.8882 19.0745C8.44266 18.0129 6.34266 15.5512 5.66599 14.649C5.46377 14.3767 5.42488 13.9995 5.61932 13.7195C5.71655 13.5795 5.86043 13.4667 6.07821 13.4551"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.48941 25.5108C7.3033 23.893 6.11719 21.7891 6.11719 19.448V15.2402"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.97944 19.825C4.86722 19.615 4 17.7133 4 16.5155C4 15.2439 4.97611 15.24 6.18167 15.24"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.6172 29.523C17.6172 29.523 18.9705 27.6875 20.565 27.2402"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.9324 13.2367C22.8235 13.194 20.4396 11.4556 18.2891 13.4428"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.5547 19.0278C22.9147 17.9428 24.9641 15.5356 25.633 14.6451C25.8352 14.3728 25.8741 13.9956 25.6797 13.7156C25.5825 13.5756 25.4386 13.4628 25.2208 13.4512"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.1766 13.455V11.4406C25.1766 6.50167 21.175 2.5 16.24 2.5H14.6922H16.5977H15.0539C10.1189 2.5 6.11719 6.50167 6.11719 11.4406V13.455"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.8086 25.5105C23.9947 23.8967 25.1808 21.7889 25.1808 19.4478V15.24"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.3428 19.8213C26.4433 19.5919 27.3028 17.7097 27.3028 16.5158C27.3028 15.2441 26.3266 15.2402 25.1211 15.2402"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.96484 7.97461H11.5904C12.2632 7.97461 12.9126 8.24294 13.3871 8.71739C13.8615 9.19183 14.511 9.46017 15.1837 9.46017H16.1443"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.3357 7.97461H19.7101C19.0374 7.97461 18.3879 8.24294 17.9135 8.71739C17.4351 9.19572 16.7896 9.46017 16.1168 9.46017H15.1562"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.2773 14.575C19.2773 14.575 20.9418 15.1077 22.0462 14.3572"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.1478 14.5752C12.1478 14.5752 10.4834 15.108 9.37891 14.3574"
                stroke="#757575"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
